import { makeStyles } from 'tss-react/mui';


export const useStyles = makeStyles({ name: 'UpliftProfileMenu' })((theme) => ({
  profileBlock: {
    display: 'inline-flex',
    alignItems: 'center',
    cursor: 'pointer',
  },
  accountAvatarWrapper: {
    width: '40px',
    height: '40px',
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    background: '#fff',
    borderRadius: '50%',
    '& svg': {
      fontSize: '50px',
    },
  },
  userName: {
    fontStyle: 'normal',
    fontWeight: 'normal',
    fontSize: '16px',
    letterSpacing: '0.5px',
    margin: theme.spacing(0, 1),
  },
  menuList: {
    marginTop: theme.spacing(5.5),
  },
}));
